import { Badge } from "@/shared/components/ui/badge";
import { BranchRole } from "../types/branch-references-base";
import { ComponentProps } from "react";

export function BranchRoleBadge({
  role,
  ...props
}: { role?: BranchRole } & ComponentProps<typeof Badge>) {
  if (!role) {
    return null;
  }

  return (
    <Badge
      {...props}
      variant={role == BranchRole.Primary ? "default" : "outline"}
    >
      {role}
    </Badge>
  );
}
